import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BodyUsedClient, BodyUsedDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-body-used-control',
  templateUrl: './body-used-control.component.html',
  styleUrls: ['./body-used-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BodyUsedControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BodyUsedControlComponent),
      multi: true,
    }
  ]
})
export class BodyUsedControlComponent extends BaseAutocompleteControl<BodyUsedDto> implements OnInit {

  constructor(
    private bodyUsedClient: BodyUsedClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<BodyUsedDto[]> {
    const cacheKey = `body_used_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.bodyUsedClient.getBodyUsedByKeySearch(searchValue).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: BodyUsedDto | null): string {
    return item?.name || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof BodyUsedDto;
  }
}
